import fetch from "auth/FetchInterceptor";

const SettingService = {};

SettingService.getSetting = function () {
  return fetch({
    url: `/settings`,
    method: "GET",
  });
};

SettingService.updateSetting = function (data) {
  return fetch({
    url: `/settings/`,
    method: "PUT",
    data,
  });
};

SettingService.reviews = function (page = 1, headers = {}) {
  return fetch({
    url: `/reviews/?page=${page}`,
    method: "GET",
    headers: {
      ...headers,
    },
  });
};

SettingService.paymentKeys = function () {
  return fetch({
    url: `/payment-keys/`,
    method: "GET",
  });
};

SettingService.shipping = function () {
  return fetch({
    url: `/shippings/`,
    method: "GET",
  });
};

SettingService.meta_keys = function () {
  return fetch({
    url: `/meta-app-credentials/`,
    method: "GET",
  });
};

SettingService.getMetaCredentials = function () {
  return fetch({
    url: `/meta-app-credentials/`,
    method: "GET",
  });
};

SettingService.updateMetaCredentials = function (data) {
  return fetch({
    url: `/meta-app-credentials/`,
    method: "POST",
    data,
  });
};

SettingService.getZone = function () {
  return fetch({
    url: `/zones/`,
    method: "GET",
  });
};

// Zone Delivery Prices APIs
SettingService.getZoneDeliveryPrices = function () {
  return fetch({
    url: `/zone-delivery-prices/`,
    method: "GET",
  });
};

SettingService.createZoneDeliveryPrice = function (data) {
  return fetch({
    url: `/zone-delivery-prices/`,
    method: "POST",
    data,
  });
};

SettingService.updateZoneDeliveryPrice = function (id, data) {
  return fetch({
    url: `/zone-delivery-prices/${id}/`,
    method: "PUT",
    data,
  });
};

SettingService.deleteZoneDeliveryPrice = function (id) {
  return fetch({
    url: `/zone-delivery-prices/${id}/`,
    method: "DELETE",
  });
};

SettingService.bulkUpdateZoneDeliveryPrices = function (data) {
  return fetch({
    url: `/zone-delivery-prices/bulk/`,
    method: "POST",
    data,
  });
};

// Area APIs
SettingService.getAreasByZone = function (zoneId) {
  return fetch({
    url: `/areas/?zone_id=${zoneId}`,
    method: "GET",
  });
};

SettingService.getAreaDeliveryPrices = function () {
  return fetch({
    url: `/area-delivery-prices/`,
    method: "GET",
  });
};

SettingService.createAreaDeliveryPrice = function (data) {
  return fetch({
    url: `/area-delivery-prices/`,
    method: "POST",
    data,
  });
};

SettingService.updateAreaDeliveryPrice = function (id, data) {
  return fetch({
    url: `/area-delivery-prices/${id}/`,
    method: "PUT",
    data,
  });
};

SettingService.deleteAreaDeliveryPrice = function (id) {
  return fetch({
    url: `/area-delivery-prices/${id}/`,
    method: "DELETE",
  });
};

SettingService.bulkCreateAreaDeliveryPrices = function (data) {
  return fetch({
    url: `/area-delivery-prices/bulk/`,
    method: "POST",
    data,
  });
};

SettingService.getAreaDeliveryPrice = function (data) {
  return fetch({
    url: `/get-area-delivery-price/`,
    method: "POST",
    data,
    headers: {
      "Store-ID": localStorage.getItem("store_id") || "1",
    },
  });
};

export default SettingService;
